'use strict';

module.exports = require('./es2015');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-dates/~/es-to-primitive/es6.js
 ** module id = 2555
 ** module chunks = 0
 **/